module.exports = __webpack_public_path__ + "files/1641fbc4ac48c62c9f4da089176d047e.svg";